import React, { useState, useEffect } from "react";
import AWS from "aws-sdk";
import Nav from "react-bootstrap/Nav";
import Form from "react-bootstrap/Form";
import { useParams, useHistory, useLocation } from "react-router-dom";
import { useCookies } from 'react-cookie';
import { Auth, API } from "aws-amplify";
import Button from "react-bootstrap/Button";
import ScrollToTop from 'react-router-scroll-top';
import LoaderButton from "../components/LoaderButton";
import { getRadioValue, checkYMD, validateSimpleDateFormat } from "../libs/utilsLib";
import AdministrativeAttrsForm from "./AdministrativeAttrsForm";
import AdministrativeAttrsConfirm from "./AdministrativeAttrsConfirm";
import RegistrationInfoForm from "./RegistrationInfoForm";
import RegistrationInfoConfirm from "./RegistrationInfoConfirm";
import AffiliationInfoForm from "./AffiliationInfoForm";
import AffiliationInfoConfirm from "./AffiliationInfoConfirm";
import HomeInfoConfirm from "./HomeInfoConfirm";
import BasicDomainInfoConfirm from "./BasicDomainInfoConfirm";
import HomeInfoForm from "./HomeInfoForm";
import BasicDomainInfoForm from "./BasicDomainInfoForm";
import AcademicHistoryInfoForm from "./AcademicHistoryInfoForm";
import AcademicHistoryInfoConfirm from "./AcademicHistoryInfoConfirm";
import CertificationInfoForm from "./CertificationInfoForm";
import CertificationInfoConfirm from "./CertificationInfoConfirm";
import CertificationInfo2FormV2 from "./CertificationInfo2FormV2";
import CertificationInfo2ConfirmV2 from "./CertificationInfo2ConfirmV2";
import RecommendersInfoConfirm from "./RecommendersInfoConfirm";
import RecommendersInfo2Confirm from "./RecommendersInfo2Confirm";
import RecommendersInfoForm from "./RecommendersInfoForm";
import RecommendersInfo2Form from "./RecommendersInfo2Form";
import OthersInfoForm from "./OthersInfoForm";
import OthersInfoConfirm from "./OthersInfoConfirm";
import libmime from "libmime";
import { useFormFields } from "../libs/hooksLib";
import { useAppContext } from "../libs/contextLib";
import { onError } from "../libs/errorLib";
import MembersInfo from "./MembersInfo";
import config from '../config';
import "./Members.css";

let glMemType = "0";

export default function Members() {

  const { id } = useParams();
  const { userProfile, isAdmin } = useAppContext();

  const [refreshCount, setRefreshCount] = useState(0);

  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);

  const [ member, setMember ] = useState(null);

  const search = useLocation().search;
  const opt = new URLSearchParams(search).get('opt');
  const [opType, setOpType] = useState(opt ? opt : 1);
  const [page, setPage] = useState("input"); // input mode as default
  const [memberTypeLabel, setMemberTypeLabel] = useState("");
  const [memStatus4Label, setMemStatus4Label] = useState("登録完了");
  const [labelSubstring, setLabelSubstring] = useState('');
  const [emailBackup, setEmailBackup] = useState('');

  const [cookies] = useCookies(['sParams']);

  let amd = new URLSearchParams(search).get('amd');
  amd = amd ? amd : 'no'; // admin mode (no: general, req : request, mgmt: management)

  const reff = new URLSearchParams(search).get('reff');

  useEffect(() => {
    console.log('useEffect called...');
    console.log(cookies.sParams);
    window.scrollTo(0, 0);
    console.log('amd=' + amd);
    console.log('opType = ' + opType);
    const onLoad = async () => {
      console.log('onLoad called...' + refreshCount);
      console.log(page);
      const anonymousUser = await Auth.currentCredentials();
      try {
        const m = await loadMember();
        console.log(m);
        setEmailBackup(m.affiliationEmail);
          setMemberTypeLabel(m.memType == 1 || m.memType == 2 || m.memType == 3 ? '正会員' : (m.memType == 4 || m.memType == 5 || m.memType == 6 ? '准会員' : (m.memType == 7 || m.memType == 8 ? '正会員（准会員から移行）' : (m.memType == 14 || m.memType == 15 || m.memType == 16 || m.memType == 17 ? '学生会員' : '会員') )));
        setLabelSubstring(m.memType == 1 || m.memType == 2 || m.memType == 3 ? '（医師・歯科医師用）' : '');
        setMemStatus4Label(m.memType == 1 || m.memType == 2 || m.memType == 3 ? '正会員' : (m.memType == 4 || m.memType == 5 || m.memType == 6 ? '准会員' : (m.memType == 7 || m.memType == 8 ? '正会員（准会員から移行）' : (m.memType == 14 || m.memType == 15 || m.memType == 16 || m.memType == 17 ? '学生会員' : '会員'))));
        let ymd = "";
        fields.birthDate = m.birthDate;
        fields.certifiedDate = m.certifiedDate;
        fields.acquiredDate = m.acquiredDate;

        fields.certifiedNo0 = m.certifiedNo0;
        fields.certifiedNo1 = m.certifiedNo1;
        fields.certifiedNo2 = m.certifiedNo2;
        fields.certifiedNo3 = m.certifiedNo3;
        fields.certifiedNo4 = m.certifiedNo4;
        fields.certifiedNo5 = m.certifiedNo5;
        fields.certifiedNo6 = m.certifiedNo6;
        fields.certifiedNo7 = m.certifiedNo7;
        fields.certifiedNo8 = m.certifiedNo8;
        fields.certifiedNo9 = m.certifiedNo9;
        fields.certifiedNo10 = m.certifiedNo10;
        fields.certifiedNo12 = m.certifiedNo12;
        fields.certifiedNo13 = m.certifiedNo13;
        fields.certifiedNo14 = m.certifiedNo14;
 
        fields.certifiedDate0 = m.certifiedDate0;
        fields.certifiedDate1 = m.certifiedDate1;
        fields.certifiedDate2 = m.certifiedDate2;
        fields.certifiedDate3 = m.certifiedDate3;
        fields.certifiedDate4 = m.certifiedDate4;
        fields.certifiedDate5 = m.certifiedDate5;
        fields.certifiedDate6 = m.certifiedDate6;
        fields.certifiedDate7 = m.certifiedDate7;
        fields.certifiedDate8 = m.certifiedDate8;
        fields.certifiedDate9 = m.certifiedDate9;
        fields.certifiedDate10 = m.certifiedDate10;
        fields.certifiedDate12 = m.certifiedDate12;
        fields.certifiedDate13 = m.certifiedDate13;
        fields.certifiedDate14 = m.certifiedDate14;

        fields.certified12Text = m.certified12Text;

        setDestination(m.destination);

        setGraduate(m.graduate);

        console.log(m.cert1Checks && Array.isArray(m.cert1Checks) ? 'array!': 'not Array');
        setCert1Checks(m.cert1Checks && Array.isArray(m.cert1Checks) ? m.cert1Checks : cert1Checks);
        setCert1Checks(m.cert1Checks);
        console.log(m.cert2Checks && Array.isArray(m.cert2Checks) ? 'array!'+m.cert2Checks.length : 'not Array');
        setCert2Checks(m.cert2Checks && Array.isArray(m.cert2Checks) ? (m.cert2Checks.length < 15 ? m.cert2Checks.concat([0,0]) : m.cert2Checks ) : cert2Checks);
//        setCert2Checks(m.cert2Checks);
        if (m.expertDomains && Array.isArray(m.expertDomains))
          setExpertDomainChecks(m.expertDomains);
        setPrimaryGames(m.primaryGames);

        fields.familyName = m.familyName;
        fields.givenName = m.givenName;
        fields.familyNameKana = m.familyNameKana;
        fields.givenNameKana = m.givenNameKana;
        setGender(m.gender);
        fields.birthDate = m.birthDate;
        fields.destination = m.destination;
        fields.affiliationName = m.affiliationName;
        fields.affiliationDepertment = m.affiliationDepertment;
        fields.affiliationPosition = m.affiliationPosition;
        fields.affiliationOccupation = m.affiliationOccupation;
        fields.affiliationPostalCode = m.affiliationPostalCode;
        fields.affiliationAddress = m.affiliationAddress;
        fields.affiliationAddressKana = m.affiliationAddressKana;
        fields.affiliationTel = m.affiliationTel;
        fields.affiliationFax = m.affiliationFax;
        fields.affiliationEmail = m.affiliationEmail;
        fields.homePostalCode = m.homePostalCode;
        fields.homeAddress = m.homeAddress;
        fields.homeAddressKana = m.homeAddressKana;
        fields.homeTel = m.homeTel;
        fields.homeFax = m.homeFax;
        fields.basicDomain = m.basicDomain;
//        fields.expertDomain = m.expertDomain;
        fields.basicDomainOther = m.basicDomainOther;
        fields.expertDomainOther = m.expertDomainOther;
        fields.academicHistory = m.academicHistory;
        fields.graduate = m.graduate;
        fields.classOfYear = m.classOfYear;
        fields.expectedToGraduateOfYear = m.expectedToGraduateOfYear;
        fields.medicalRegistrationNumber = m.medicalRegistrationNumber;
        fields.certifiedDate = m.certifiedDate;
//        fields.cert1Checks = cert1Checks; // 
        fields.degree = m.degree;
        fields.certificationNumber = m.certificationNumber;
        fields.acquiredDate = m.acquiredDate;
//        fields.cert2Checks = m.cert2Checks;
        fields.recommender = m.recommender;
        fields.reasonForRecommend = m.reasonForRecommend;
        fields.recommender1 = m.recommender1;
        fields.reasonForRecommend1 = m.reasonForRecommend1;
        fields.recommender2 = m.recommender2;
        fields.reasonForRecommend2 = m.reasonForRecommend2;
        fields.biography = m.biography;
        fields.activitiesForTheField = m.activitiesForTheField;
        fields.papersAndPerformanceHistory = m.papersAndPerformanceHistory;
        fields.motivationsAndAspirations = m.motivationsAndAspirations;

        // administrative form
        fields.loginId = "NotAssignedYet" == m.data ? "" : m.data;
        fields.admissionRequestDate = m.admissionRequestDate;
        fields.admissionDate = m.admissionDate;
        if (m.memStatus) setMemStatus(m.memStatus);
        if (m.memType) {
        const ot = (m.memType == 1 || m.memType == 2 || m.memType == 3 || m.memType == 9 ? 1 : (m.memType == 14 || m.memType == 15 || m.memType == 16 || m.memType == 17 ? 14 : 2));
          console.log('### reset memType after load...');
          setMemType(m.memType);
          setSavedMemType(m.memType);
          setOpType(ot);
          console.log('memType = '+ m.memType + 'opType reset to "' + ot + '"');
          setSavedType(m.memType); // backup saved original memType
        }
        //if (amd == 'transfer') setMemType(7); // 7: 申請（准会員から正会員)
        if (m.memClass) setMemClass(m.memClass);
        if (m.memPost) setMemPost(m.memPost);
        if (m.memCommittee) setMemCommittee(m.memCommittee);
        if (m.memRepresentative) setMemRepresentative(m.memRepresentative);
        if (m.memPaymentMethod) setMemPaymentMethod(m.memPaymentMethod);
        fields.postAndCommittee = m.postAndCommittee;
        fields.committeeActiveHistories = m.committeeActiveHistories;
        fields.termOfRepresentative = m.termOfRepresentative;
        fields.termOfDirective = m.termOfDirective;
        fields.academicAwards = m.academicAwards;
        fields.accountPayable = m.accountPayable;
        fields.teamHistories = m.teamHistories;
        fields.unsubscribeDate = m.unsubscribeDate;
        fields.transitionDate = m.transitionDate;
        fields.shipments = m.shipments;
        fields.classRemarks = m.classRemarks;
        fields.remarks = m.remarks;
        setMember(m);
        document.querySelector('.red').style.display = 'none';
        showAdminOptionItems(!(m.memType == 1 || m.memType == 2 || m.memType == 4 || m.memType == 5 || m.memType == 6 || m.memType == 10));
     } catch(e) {
        onError(e);
      }
    };
    onLoad();
   },[]);

  // memStatus (Member Status) radio
  const [memStatus, setMemStatus] = useState(0);
  // memType (Member Type) radio
  const [memType, setMemType] = useState(0);
  const [savedMemType, setSavedMemType] = useState(0);
  // savedType for original saved member type
  const [savedType, setSavedType] = useState(0);
  // memClass (Member Classification) radio
  const [memClass, setMemClass] = useState(0);
  // memPaymentMethod radio
  const [memPaymentMethod, setMemPaymentMethod] = useState(0);
  // memPost (Member Post) checkbox
  const [memPost, setMemPost] = useState([0,0,0,0,0]);
  // memCommittee (Member Committee) checkbox
  const [memCommittee, setMemCommittee] = useState([0,0,0,0,0,0,0,0,0,0]);
  // memRepresentative (Member Representative) checkbox
  const [memRepresentative, setMemRepresentative] = useState([0]);

  // gender radio
  const [gender, setGender] = useState(0);
  const [genderMessage, setGenderMessage] = useState('');
  // destination radio
  const [destination, setDestination] = useState(0);
  const [destinationMessage, setDestinationMessage] = useState('');
  // graduate radio
  const [graduate, setGraduate] = useState(0);
  const [graduateMessage, setGraduateMessage] = useState('');

  // primary games supported radio
  const [primaryGames, setPrimaryGames] = useState(0);
  const [primaryGamesMessage, setPrimaryGamesMessage] = useState('');

  // expert domain checkbox
  const [expertDomainChecks, setExpertDomainChecks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  // cert1 checkbox
  const [cert1Checks, setCert1Checks] = useState([0,0,0,0,0,0]);
  // cert2 checkbox
  const [cert2Checks, setCert2Checks] = useState([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]);

  const [emailMismatchMessage, setEmailMismatchMessage] = useState('');
  const [basicDomainOtherMessage, setBasicDomainOtherMessage] = useState('');
  const [expertDomainOtherMessage, setExpertDomainOtherMessage] = useState('');
  const [cert1ChecksMessage, setCert1ChecksMessage] = useState('');
  const [cert2ChecksMessage, setCert2ChecksMessage] = useState('');
  const [expertDomainChecksMessage, setExpertDomainChecksMessage] = useState('');

  const getCertNoErrorMsg = (checkId, value) => {
    if (!document.getElementById(checkId)) return '';
    const isck = document.getElementById(checkId).checked;
    if (!value && isck) {
      const mes = '認定資格番号を入力してください。';
      return mes;
    }
    return '';
  };

  const getCertDateErrorMsg = (checkId, value) => {
      if (!document.getElementById(checkId)) return '';
      const isck = document.getElementById(checkId).checked;
      if (isck) {
        if (!value) {
          const mes = '取得年月日を入力してください。';
          console.log(mes);
          return mes;
	}
        const arr = value.split('/');
        let mes = '2021/06/07 の形式で入力してください。';
        if (arr.length != 3) return mes;
        if (!(arr[0].length == 4 && arr[1].length == 2 && arr[2].length == 2)) {
          return mes;
        }	      
      }
      return '';
  };

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    postAndCommittee: "",
    committeeActiveHistories: "",
    termOfRepresentative: "",
    termOfDirective: "",
    academicAwards: "",
    accountPayable: "",
    teamHistories: "",
    unsubscribeDate: "",
    transitionDate: "",
    shipments: "",
    classRemarks: "",
    remarks: "",
    loginId: "",
    password: "",
    confirmPassword: "",
    confirmationCode: "",
    admissionRequestDate: "",
    admissionDate: "",
    familyName: "",
    givenName: "",
    familyNameKana: "",
    givenNameKana: "",
//    gender: "0",
    birthDate: "",
    certifiedY: "",
    certifiedM: "",
    certifiedD: "",
    certifiedNo0: "",
    certifiedNo1: "",
    certifiedNo2: "",
    certifiedNo3: "",
    certifiedNo4: "",
    certifiedNo5: "",
    certifiedNo6: "",
    certifiedNo7: "",
    certifiedNo8: "",
    certifiedNo9: "",
    certifiedNo10: "",
    certifiedNo12: "",
    certified12Text: "",
    certifiedNo13: "",
    certifiedNo14: "",
    certifiedDate0: "",
    certifiedDate1: "",
    certifiedDate2: "",
    certifiedDate3: "",
    certifiedDate4: "",
    certifiedDate5: "",
    certifiedDate6: "",
    certifiedDate7: "",
    certifiedDate8: "",
    certifiedDate9: "",
    certifiedDate10: "",
    certifiedDate12: "",
    certifiedDate13: "",
    certifiedDate14: "",
    acquiredDate: "",
    affiliationName: "",
    affiliationDepertment: "",
    affiliationPosition: "",
    affiliationOccupation: "",
    affiliationPostalCode: "",
    affiliationAddress: "",
    affiliationAddressKana: "",
    affiliationTel: "",
    affiliationFax: "",
    affiliationEmail: "",
    affiliationEmailConfirmation: "",
    homePostalCode: "",
    homeAddress: "",
    homeAddressKana: "",
    homeTel: "",
    homeFax: "",
    basicDomain: "",
    basicDomainOther: "",
    expertDomainOther: "",
    academicHistory: "",
    classOfYear: "",
    expectedToGraduateOfYear: "",
    medicalRegistrationNumber: "",
    acquisitionYear: "",
    acquisitionMonth: "",
    acquisitionDay: "",
    degree: "",
    certificationNumber: "",
    recommender: "",
    reasonForRecommend: "",
    recommender1: "",
    reasonForRecommend1: "",
    recommender2: "",
    reasonForRecommend2: "",
    biography: "",
    activitiesForTheField: "",
    papersAndPerformanceHistory: "",
    motivationsAndAspirations: "",
  },
  {
    postAndCommittee: {n:"", f: (value) => { console.log(value); return ''}},
    committeeActiveHistories: {n:"", f: (value) => { console.log(value); return ''}},
    termOfRepresentative: {n:"", f: (value) => { console.log(value); return ''}},
    termOfDirective: {n:"", f: (value) => { 
      console.log(value);
      if (value) { return validateSimpleDateFormat(value);}
      return '';
    }},
    academicAwards: {n:"", f: (value) => { console.log(value); return ''}},
    accountPayable: {n:"", f: (value) => { console.log(value); return ''}},
    teamHistories: {n:"", f: (value) => { console.log(value); return ''}},
    unsubscribeDate: {n:"", f: (value) => { console.log(value); return ''}},
    transitionDate: {n:"", f: (value) => {
      console.log(value);
      if (value) { return validateSimpleDateFormat(value);}
      return '';
    }},
    shipments: {n:"", f: (value) => { console.log(value); return '' }},
    classRemarks: {n:"", f: (value) => { console.log(value); return '' }},
    remarks: {n:"", f: (value) => { console.log(value); return '' }},
    loginId: {n:"", f: (value) => {
	console.log('loginid ...' + opType);
      if (value || 0 != opType)
        return ''; 
      else { 
        console.log('setRef.....'); 
        //setRefreshCount(refreshCount+1); 
        return '';
      }
    }},
    password: {n:"", f: (value) => { console.log(value); return '' }},
    confirmPassword: {n:"", f: (value) => { console.log(value); return ''}},
    confirmationCode: {n:"", f: (value) => { console.log(value); return ''}},
    admissionRequestDate: {n:"", f: (value) => { 
        console.log(value);
        if (value) { return validateSimpleDateFormat(value);}
        return '';
    }},
    admissionDate: {n:"", f: (value) => { 
        console.log(value);
        if (value) { return validateSimpleDateFormat(value);}
        return '';
    }},
    familyName: {n:"", f: (value) => {
        console.log('familyName...');
        console.log(value);
        console.log(fields.familyName);
        if (!value && !isAdmin) 
          return '氏名(姓)を入力してください。';
        return '';
    }},
    givenName: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) 
        return '氏名(名)を入力してください。';
      return '';
    }},
    familyNameKana: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) 
        return '氏名(セイ)を入力してください。';
      return '';
    }},
    givenNameKana: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) 
        return '氏名(メイ)を入力してください。';
      return '';
    }},
//    gender: {n:"", f: (value) => {
//      if (value == 0) 
//        return '性別を指定してください。';
//      return '';
//    }},
    birthDate: {n:"", f: (value) => {
      console.log('birth date...');
      if (!value)
        return '生年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    certifiedDate: {n:"", f: (value) => { 
      console.log('####memType = ' + getRadioValue('memType'));
      if (generalMemberType() != 1) return '';
      if (!value)
        return '取得年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    certifiedNo0: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks0', value);
    }},
    certifiedNo1: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks1', value);
    }},
    certifiedNo2: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks2', value);
    }},
    certifiedNo3: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks3', value);
    }},
    certifiedNo4: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks4', value);
    }},
    certifiedNo5: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks5', value);
    }},
    certifiedNo6: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks6', value);
    }},
    certifiedNo7: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks7', value);
    }},
    certifiedNo8: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks8', value);
    }},
    certifiedNo9: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks9', value);
    }},
    certifiedNo10: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks10', value);
    }},
    certifiedNo12: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks12', value);
    }},
    certifiedNo13: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks13', value);
    }},
    certifiedNo14: {n:"", f: (value) => {
      return getCertNoErrorMsg('cert2Checks14', value);
    }},
    certified12Text: {n:"", f: (value) => {
      if (!document.getElementById('cert2Checks12')) return '';
      const isck = document.getElementById('cert2Checks12').checked;
      if (!value && isck) {
        const mes = 'その他の資格・身分の名称を入力してください。';
        return mes;
      } else
        return "";
    }},
    certifiedDate0: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks0', value);
    }},
    certifiedDate1: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks1', value);
    }},
    certifiedDate2: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks2', value);
    }},
    certifiedDate3: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks3', value);
    }},
    certifiedDate4: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks4', value);
    }},
    certifiedDate5: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks5', value);
    }},
    certifiedDate6: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks6', value);
    }},
    certifiedDate7: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks7', value);
    }},
    certifiedDate8: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks8', value);
    }},
    certifiedDate9: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks9', value);
    }},
    certifiedDate10: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks10', value);
    }},
    certifiedDate12: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks12', value);
    }},
    certifiedDate13: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks13', value);
    }},
    certifiedDate14: {n:"", f: (value) => {
      return getCertDateErrorMsg('cert2Checks14', value);
    }},
    acquiredDate: {n:"", f: (value) => {
      if (!(memType == 4 || memType == 5 || memType == 6)) return '';
      if (!value)
        return '取得年月日を入力してください。';
      const ar = value.split('/');
      console.log(ar.length);
      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
        return '';
      return '2021/03/04 の形式で入力してください。';
    }},
    affiliationName: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '名称を入力してください。';
      return '';
    }},
//    affiliationName: {n:"", f: (value) => {
    affiliationDepertment: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '部署を入力してください。';
      return '';
    }},
    affiliationPosition: {n:"", f: (value) => {
      return '';
    }}, 
    affiliationOccupation: {n:"", f: (value) => {
      console.log(value);
      console.log('memType:');
      console.log(glMemType);
      if (!value && !isAdmin && !(glMemType == 16)) return '職種を入力してください。';
      return '';
    }}, 
    affiliationPostalCode: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '郵便番号を入力してください。';
      return '';
    }},
    affiliationAddress: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '所在地を入力してください。';
      return '';
    }},
    affiliationAddressKana: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '所在地（フリガナ）を入力してください。';
      return '';
    }},
    affiliationTel: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '電話番号を入力してください。';
      return '';
    }},
    affiliationFax: {n:"", f: (value) => { console.log(value); return '' }},
    affiliationEmail: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return 'Emailを入力してください。';
      if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
      const arr = value.split('@');
      if (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2)  return 'Email アドレスの形式が不正です。';
      return '';
    }},
    affiliationEmailConfirmation: {n:"", f: (value) => {
      const org = document.getElementById('affiliationEmail').value;
      console.log(value);
      
      if (!isAdmin && !value) return 'Email（確認用）を入力してください。';
      if (value.match(/^[a-zA-Z0-9!-/:-@¥[-`{-~]*$/) == null) return 'Email アドレスは半角で入力してください。';
      const arr = value.split('@');
      if (!isAdmin && (arr.length != 2 || arr[0].length < 1 || arr[1].length < 1 || arr[1].split('.').length < 2))  return 'Email アドレスの形式が不正です。';
      if (org == value) setEmailMismatchMessage('');
      return '';
    }},
    homePostalCode: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '郵便番号を入力してください。';
      return '';
    }},
    homeAddress: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '現住所を入力してください。';
      return '';
    }},
    homeAddressKana: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '現住所（フリガナ）を入力してください。';
      return '';
    }},
    homeTel: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '電話番号を入力してください。';
      return '';
    }},
    homeFax: {n:"", f: (value) => { console.log(value); return '' }},
    basicDomain: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin && (memType == 4 || memType == 5 || memType == 6)) return 'ベーシック領域を選択してください。';
      return '';
    }},
    basicDomainOther: {n:"", f: (value) => {
      if (value) setBasicDomainOtherMessage('');
      return '';
    }},
    expertDomainOther: {n:"", f: (value) => {
      console.log(value);
      if (value) setExpertDomainOtherMessage('');
      return ''
    }},
    academicHistory: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '最終学歴を入力してください。';
      return '';
    }},
    classOfYear: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin) return '卒業年度を入力してください。';
      return '';
    }},
    expectedToGraduateOfYear: {n:"", f: (value) => {
      console.log('expectedToGraduateOfYear value...' + memType);
      console.log(value);

      if (value) {
        console.log('#check digit: ' + value.match(/[^0-9]/));
      }

      console.log(memType);
      if ((memType == 14) && !(value && value.length == 4) ) return '卒業予定を西暦で入力してください。';
      if ((memType == 14) && value.match(/[^0-9]/) != null) return '卒業予定は半角数字で入力してください。';
      return '';
    }},
    medicalRegistrationNumber: {n:"", f: (value) => {
      console.log(value);
      if (!value && !isAdmin && (memType == 4 || memType == 5 || memType == 6)) return '医籍登録番号を入力してください。';
      return '';
    }},
    acquisitionYear: {n:"", f: (value) => { console.log(value); return '' }},
    acquisitionMonth: {n:"", f: (value) => { console.log(value); return '' }},
    acquisitionDay: {n:"", f: (value) => { console.log(value); return '' }},
    degree: {n:"", f: (value) => {
      console.log(value);
      if ((amd == 'transfer' && !value) || (generalMemberType() == 2 && !value && !isAdmin)) return '学位を入力してください。';
      return '';
    }},
    certificationNumber: {n:"", f: (value) => {
      console.log(value);
      if (!value && 2 == generalMemberType() && !isAdmin) return '取得資格番号を入力してください。';
      return '';
    }},
    recommender: {n:"", f: (value) => {
      console.log(value);
      if (generalMemberType() == 2 && !value && !isAdmin) return '推薦者を入力してください。';
       return '';
    }},
    reasonForRecommend: {n:"", f: (value) => { console.log(value); return '' }},
    recommender1: {n:"", f: (value) => {
      console.log(value);
      if (amd == 'transfer' && !value) return '推薦者１を入力してください。';
      return ''
    }},
    reasonForRecommend1: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return '推薦理由１を入力してください。';
      return ''
    }},
    recommender2: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return '推薦者２を入力してください。';
      return ''
    }},
    reasonForRecommend2: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return '推薦理由２を入力してください。';
      return ''
    }},
    biography: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return '略歴を入力してください。';
      return ''
    }},
    activitiesForTheField: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return 'スポーツ現場に関わる活動を入力してください。';
      return ''
    }},
    papersAndPerformanceHistory: {n:"", f: (value) => {
      console.log(value)
      if (amd == 'transfer' && !value) return '原著論文・学会発表歴を入力してください。';
      return ''
    }},
    motivationsAndAspirations: {n:"", f: (value) => {
      console.log(value)
      //if (amd == 'transfer' && !value) return '入会希望の動機と抱負を入力してください。';
      return ''
    }},
 });

  const vldNamesByHand = {
    "gender": genderMessage,
    "destination": destinationMessage,
    "affiliationEmailConfirmation": emailMismatchMessage,
    "expertDomainChecks19": expertDomainChecksMessage,
    "graduate": graduateMessage,
    "cert1Checks0": cert1ChecksMessage,
    "cert2Checks0": cert2ChecksMessage,
  };

  function loadMember() {
    return API.get("sakurajima", `/members/${id}`); 
  }

  function generalMemberType() {
      const mt = getRadioValue('memType');
      console.log('in general member type : ' + mt);
      return mt == 1 || mt == 2 || mt == 3 ? 1 : (mt == 4 || mt == 5 || mt == 6 ? 2 : 3);
  };

  function validateForm() {
//    console.log(messages);
    let b = doValidation();
    console.log('doValidation return: ' + b);
    console.log('isAdmin: ' + isAdmin);
    let c = (0 == gender);
    if (b) b = !c;
    let m = c ? '性別を選択してください' : '' ;
    setGenderMessage(m);
    console.log('!!!!!:' + b);

    c = (0 == destination);
    if (b && !isAdmin) b = !c;
    m = c ? '送付先を選択してください' : '' ;
    setDestinationMessage(m);
    console.log('!!!!!:' + b);

    if (!isAdmin && (fields.affiliationEmailConfirmation != fields.affiliationEmail)) {
      c = true
      if (b) b = !c;
      m = c ? 'Email（確認用）が一致していません。' : '' ;
      setEmailMismatchMessage(m);
      console.log(m);
    }

    console.log('basicDomain....' + fields.basicDomain);
    if (19 == fields.basicDomain) {
      c = (1 > fields.basicDomainOther.length);
      if (b) b = !c;
      m = c ? 'その他の内容を入力してください' : '' ;
      setBasicDomainOtherMessage(m);
    }

    if (19 == fields.expertDomain) {
      c = (1 > fields.expertDomainOther.length);
      if (b) b = !c;
      m = c ? 'その他の内容を入力してください' : '' ;
      setExpertDomainOtherMessage(m);
    }

    c = (0 == graduate);
    if (b) b = !c;
    m = c ? '大学/大学院を指定してください。' : ''; 
    setGraduateMessage(m);
    console.log('!!!!!:' + b);

    c = (
      (parseInt(expertDomainChecks[0]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[1]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[2]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[3]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[4]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[5]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[6]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[7]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[8]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[9]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[10]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[11]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[12]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[13]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[14]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[15]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[16]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[17]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[18]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[19]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[20]) > 0 ? 1 : 0) +
      (parseInt(expertDomainChecks[21]) > 0 ? 1 : 0)
    );
    if (b && 2 != opType) b = (c > 0 && c < 4);
    m = c == 0 ? 'エクスパート領域を一つ以上選択してください。' : ( c > 3 ? 'エクスパート領域の選択は３つまでです。' : ''); 
    setExpertDomainChecksMessage(m);
    console.log(m);
    console.log(b + ' 1.5');

    c = (0 == primaryGames);
    if (b && 2 != opType) b = !c;
    m = c ? '主としてサポートしている競技の分類を指定してください。' : ''; 
    console.log(m);
    setPrimaryGamesMessage(m);
    console.log(m);
    console.log(b + ' 1.6');

/*
    c = (0 == acquiredEra);
    if (b && 2 == generalMemberType() && !isAdmin) b = !c;
    m = c ? '元号を指定してください。' : ''; 
    setAcquiredEraMessage(m);
    console.log('!!!!!:' + b);

    c = ("" == fields.acquiredY || "" == fields.acquiredM || "" == fields.acquiredD);
    if (b && 2 == generalMemberType() && !isAdmin) b = !c;
    m = c ? '取得年月日は必須です' : ''; 
    if (!c) {
	c = !checkYMD(fields.acquiredY, fields.acquiredM, fields.acquiredD);
        if (b) b = !c;
        m = c ? '取得年、月、日は半角2桁で入力してください。（例： 22 年 03 月 07 日）' : '';
    }
    setAcquiredYMDMessage(m);
*/
    c = (
      0 == cert1Checks[0] &&
      0 == cert1Checks[1] &&
      0 == cert1Checks[2] &&
      0 == cert1Checks[3] &&
      0 == cert1Checks[4] &&
      0 == cert1Checks[5]);
    if (b && 1 == generalMemberType() && !isAdmin) b = !c;
    m = c ? '取得スポーツ医資格を一つ以上選択してください。' : ''; 
    setCert1ChecksMessage(m);

    c = (
      0 == cert2Checks[0] && 
      0 == cert2Checks[1] && 
      0 == cert2Checks[2] && 
      0 == cert2Checks[3] && 
      0 == cert2Checks[4] && 
      0 == cert2Checks[5] && 
      0 == cert2Checks[6] && 
      0 == cert2Checks[7] && 
      0 == cert2Checks[8] && 
      0 == cert2Checks[9] && 
      0 == cert2Checks[10] && 
      0 == cert2Checks[11] && 
      0 == cert2Checks[12] && 
      0 == cert2Checks[13] && 
      0 == cert2Checks[14]);
    if (b && 1 != opType && !isAdmin) b = !c;
    m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert2ChecksMessage(m);

    return b; 
  }


  function updateValidationMessages() {
    console.log('updateValidationMessages...');
      for(let key in messages) {
	  console.log(key + ' = ' + messages[key].n);
          const  mElmt = document.getElementById(key+'Message');
          if (mElmt)
            mElmt.textContent = messages[key].n;

      }
  }

  const updateMember = (member) => {
    console.log("updateMember...");
    console.log(member);
    return API.put('sakurajima', `/members/${id}`, {
      body: member
    });
  };

  function handleExpertDomainChecksChange(event) {
    const n = event.target.name;
    console.log(event.target);
    console.log(n.substring('expertDomainChecks'.length));
    const i = n.substring('expertDomainChecks'.length);
    let chs = JSON.parse(JSON.stringify(expertDomainChecks));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setExpertDomainChecks(chs);

    const c = (
      (parseInt(chs[0]) > 0 ? 1 : 0) +
      (parseInt(chs[1]) > 0 ? 1 : 0) +
      (parseInt(chs[2]) > 0 ? 1 : 0) +
      (parseInt(chs[3]) > 0 ? 1 : 0) +
      (parseInt(chs[4]) > 0 ? 1 : 0) +
      (parseInt(chs[5]) > 0 ? 1 : 0) +
      (parseInt(chs[6]) > 0 ? 1 : 0) +
      (parseInt(chs[7]) > 0 ? 1 : 0) +
      (parseInt(chs[8]) > 0 ? 1 : 0) +
      (parseInt(chs[9]) > 0 ? 1 : 0) +
      (parseInt(chs[10]) > 0 ? 1 : 0) +
      (parseInt(chs[11]) > 0 ? 1 : 0) +
      (parseInt(chs[12]) > 0 ? 1 : 0) +
      (parseInt(chs[13]) > 0 ? 1 : 0) +
      (parseInt(chs[14]) > 0 ? 1 : 0) +
      (parseInt(chs[15]) > 0 ? 1 : 0) +
      (parseInt(chs[16]) > 0 ? 1 : 0) +
      (parseInt(chs[17]) > 0 ? 1 : 0) +
      (parseInt(chs[18]) > 0 ? 1 : 0) +
      (parseInt(chs[19]) > 0 ? 1 : 0) +
      (parseInt(chs[20]) > 0 ? 1 : 0) +
      (parseInt(chs[21]) > 0 ? 1 : 0)
    );

    console.log('count = ' + c);
    const m = c == 0 ? 'エクスパート領域を一つ以上選択してください。' : ( c > 3 ? 'エクスパート領域の選択は３つまでです。' : ''); 
    setExpertDomainChecksMessage(m);
  }

  function handleCert1ChecksChange(event) {
    const n = event.target.name;
    console.log(n);
    console.log(n.substring('cert1Checks'.length));
    const i = parseInt(n.substring('cert1Checks'.length));
    console.log(cert1Checks);
    console.log(typeof cert1Checks);
   
    let chs = Array.isArray(cert1Checks) ? JSON.parse(JSON.stringify(cert1Checks)) : [0,0,0,0,0,0];
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setCert1Checks(chs);

    const c = (
      0 == chs[0] &&
      0 == chs[1] &&
      0 == chs[2] &&
      0 == chs[3] &&
      0 == chs[4] &&
      0 == chs[5] &&
      0 == chs[6] &&
      0 == chs[7] &&
      0 == chs[8] &&
      0 == chs[9] &&
      0 == chs[10] &&
      0 == chs[11] &&
      0 == chs[12]
    );
    const m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert1ChecksMessage(m);
  }

/*
  function handleCertifiedDateChange(event) {
    console.log('#### memType = ' + memType);
    handleFieldChange(event);

    const value = event.target.value;
    console.log(value);
    let m = '';
    if (1 == generalMemberType()) {
      if (!value)
        m = '取得年月日を入力してください。';
//      const ar = value.split('/');
//      console.log(ar.length);
//      if (ar.length == 3 && checkYMD(ar[0], ar[1], ar[2]))
//        return '';
//      return '2021/03/04 の形式で入力してください。';
    }
    setCertifiedDateMessage(m);

    return false;
  }
*/

  function handleCert2ChecksChange(event) {
    const n = event.target.name;
    console.log(n.substring('cert2Checks'.length));
    const i = parseInt(n.substring('cert2Checks'.length));
    let chs = JSON.parse(JSON.stringify(cert2Checks));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    console.log(chs);
    setCert2Checks(chs);
    const c = (
      0 == chs[0] && 
      0 == chs[1] && 
      0 == chs[2] && 
      0 == chs[3] && 
      0 == chs[4] && 
      0 == chs[5] && 
      0 == chs[6] && 
      0 == chs[7] && 
      0 == chs[8] && 
      0 == chs[9] && 
      0 == chs[10] && 
      0 == chs[11] && 
      0 == chs[12] && 
      0 == chs[13] && 
      0 == chs[14]);
    const m = c ? '資格・身分を一つ以上選択してください。' : ''; 
    setCert2ChecksMessage(m);
  }

  function handleSetGender(event) {
      console.log('handleSetGender...');
      setGender(event.target.value);
      setGenderMessage('');
  }


  function handleSetDestination(event) {
      console.log('handleSetDestination...');
      setDestination(event.target.value);
      setDestinationMessage('');
  }

  function handleSetGraduate(event) {
      console.log('handleSetGraduate...');
      setGraduate(event.target.value);
      setGraduateMessage('');
  }

  function handlePrimaryGamesChange(event) {
      console.log('handlePrimaryGamesChange...');
      setPrimaryGames(event.target.value);
      setPrimaryGamesMessage('');
  }
  
  function handleMemPostChange(event) {
    const n = event.target.name;
    console.log(event.target.value);
    const i = parseInt(n.substring(n.length - 1));
    let chs = JSON.parse(JSON.stringify(memPost));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
    setMemPost(chs);
  }

  const createAnnualFee = (data) => {
    return API.post('sakurajima', '/fees', {
      body: data
    });
  };

  const updateEmail = async () => {
    console.log('login username: ' + fields.loginId);

//    const user = await Auth.currentAuthenticatedUser();
    if (emailBackup != fields.affiliationEmail) {
      const params = {
        UserPoolId: config.awssdk.USER_POOL_ID, // required
        Username: fields.loginId, // required
        UserAttributes: [ // required 
          {
            Name: 'email', // メールアドレス属性を指定
            Value: fields.affiliationEmail
          },
          {
            Name: 'email_verified',
            Value: 'true'
          }
        ],
      };
/*
	try {
      console.log('email backup = ' + emailBackup);
      console.log('affiliation email = ' + fields.affiliationEmail);
      await cognito.adminUpdateUserAttributes(params).promise();
	} catch (e) {
            console.error(e);
            throw(e);
	}
*/
//      await Auth.updateUserAttributes(user, {
//        'email': fields.affiliationEmail,
//        email_verified: true
//      });
    }
  };

  async function handleConfirmationSubmit(event) {
    event.preventDefault();

    setIsLoading(true);
    console.log('handleConfirmationSubmit...');
    console.log('savedMemType: ' + savedMemType);
    console.log('memType: ' + memType);

    try {
      let updatedMemClass = memClass;
      console.log('savedMemType: ' + savedMemType);
      console.log('memType: ' + memType);
      updateEmail();
      console.log('savedMemType3: ' + savedMemType);
      console.log('memType3: ' + memType);
      if (((savedMemType == 1 || savedMemType == 2) && memType == 3)
        || ((savedMemType == 4 || savedMemType == 5 || savedMemType == 10) && memType == 6)
        || ((savedMemType == 14 || savedMemType == 15 || savedMemType == 17) && memType == 16)) {
        const today = new Date();
	console.log('month of today: ' + today.getMonth());
	console.log('day of today: ' + today.getDate());
        console.log('localtime : ' + today.toLocaleString());
        if (fields.admissionDate && fields.admissionDate.trim().length < 1) {
          onError('入会日を設定してください。');
          return;
        }
        console.log(fields.admissionDate);
        console.log(fields.admissionDate.split('/'))
        const splittedAdDate = fields.admissionDate.split('/');
        //let year = today.getFullYear() - (today.getMonth() < 10 ? 1 : 0);
        let year = parseInt(splittedAdDate[0]) - (parseInt(splittedAdDate[1]) < 10 ? 1 : 0);
        await createAnnualFee({
          "id": id,
          "memberId": fields.loginId, // memberId is loginId
          "memType": memType,
          "admissionDate": fields.admissionDate,
          "year": year.toString(),
          "status": "0",
          "dateOfPayment": ""
        });
        year = year + 1;
        await createAnnualFee({
          "id": id,
          "memberId": fields.loginId, // memberId is loginId
          "memType": memType,
          "admissionDate": fields.admissionDate,
          "year": year.toString(),
          "status": "0",
          "dateOfPayment": ""
        });
        setMemClass(1);
        updatedMemClass = 1;
      }
      const birthDate = fields.birthDate;
      const certifiedDate = fields.certifiedDate;
      const acquiredDate = fields.acquiredDate;
	console.log('fields of updateMember');            
	console.log(fields);            
      const m = await updateMember({
          memberType: "MEMBER",
          state: "REQUESTED",
          familyName: fields.familyName,
          givenName: fields.givenName,
          familyNameKana: fields.familyNameKana,
          givenNameKana: fields.givenNameKana,
          gender: gender,
          birthDate: birthDate,
          destination: destination,
          affiliationName: fields.affiliationName,
          affiliationDepertment: fields.affiliationDepertment,
          affiliationPosition: fields.affiliationPosition,
          affiliationOccupation: fields.affiliationOccupation,
          affiliationPostalCode: fields.affiliationPostalCode,
          affiliationAddress: fields.affiliationAddress,
          affiliationAddressKana: fields.affiliationAddressKana,
          affiliationTel: fields.affiliationTel,
          affiliationFax: fields.affiliationFax,
          affiliationEmail: fields.affiliationEmail,
          homePostalCode: fields.homePostalCode,
          homeAddress: fields.homeAddress,
          homeAddressKana: fields.homeAddressKana,
          homeTel: fields.homeTel,
          homeFax: fields.homeFax,
          basicDomain: fields.basicDomain,
          expertDomains: expertDomainChecks,
          basicDomainOther: fields.basicDomainOther,
          expertDomainOther: fields.expertDomainOther,
          primaryGames: primaryGames,
          academicHistory: fields.academicHistory,
          graduate: graduate,
          classOfYear: fields.classOfYear,
          medicalRegistrationNumber: fields.medicalRegistrationNumber,
          expectedToGraduateOfYear: fields.expectedToGraduateOfYear,
          certifiedDate: certifiedDate,
          cert1Checks: cert1Checks,
          certifiedNo0: fields.certifiedNo0,
          certifiedDate0: fields.certifiedDate0,
          certifiedNo1: fields.certifiedNo1,
          certifiedDate1: fields.certifiedDate1,
          certifiedNo2: fields.certifiedNo2,
          certifiedDate2: fields.certifiedDate2,
          certifiedNo3: fields.certifiedNo3,
          certifiedDate3: fields.certifiedDate3,
          certifiedNo4: fields.certifiedNo4,
          certifiedDate4: fields.certifiedDate4,
          certifiedNo5: fields.certifiedNo5,
          certifiedDate5: fields.certifiedDate5,
          certifiedNo6: fields.certifiedNo6,
          certifiedDate6: fields.certifiedDate6,
          certifiedNo7: fields.certifiedNo7,
          certifiedDate7: fields.certifiedDate7,
          certifiedNo8: fields.certifiedNo8,
          certifiedDate8: fields.certifiedDate8,
          certifiedNo9: fields.certifiedNo9,
          certifiedDate9: fields.certifiedDate9,
          certifiedNo10: fields.certifiedNo10,
          certifiedDate10: fields.certifiedDate10,
          certified12Text: fields.certified12Text,
          certifiedNo12: fields.certifiedNo12,
          certifiedDate12: fields.certifiedDate12,
          certifiedNo13: fields.certifiedNo13,
          certifiedDate13: fields.certifiedDate13,
          certifiedNo14: fields.certifiedNo14,
          certifiedDate14: fields.certifiedDate14,
          degree: fields.degree,
          certificationNumber: fields.certificationNumber,
          acquiredDate: acquiredDate,
          cert2Checks: cert2Checks,
          recommender: fields.recommender,
          reasonForRecommend: fields.reasonForRecommend,
          recommender1: fields.recommender1,
          reasonForRecommend1: fields.reasonForRecommend1,
          recommender2: fields.recommender2,
          reasonForRecommend2: fields.reasonForRecommend2,
          biography: fields.biography,
          activitiesForTheField: fields.activitiesForTheField,
          papersAndPerformanceHistory: fields.papersAndPerformanceHistory,
          motivationsAndAspirations: fields.motivationsAndAspirations,
          memberId: fields.loginId, // memberId is loginId
          admissionRequestDate: fields.admissionRequestDate,
          admissionDate: fields.admissionDate,
          memStatus: memStatus.toString(),
          memType: (amd == 'transfer') ? '7' : memType.toString(),
          memClass: updatedMemClass.toString(),
          memPost: memPost,
          memCommittee: memCommittee,
          memRepresentative: memRepresentative,
          postAndCommittee: fields.postAndCommittee,
          committeeActiveHistories: fields.committeeActiveHistories,
          termOfRepresentative: fields.termOfRepresentative,
          termOfDirective: fields.termOfDirective,
          academicAwards: fields.academicAwards,
          accountPayable: fields.accountPayable,
          teamHistories: fields.teamHistories,
          unsubscribeDate: fields.unsubscribeDate,
          memPaymentMethod: memPaymentMethod.toString(),
          transitionDate:fields.transitionDate,
          shipments:fields.shipments,
          classRemarks:fields.classRemarks,
          remarks:fields.remarks,
	  authStatus: member.authStatus
      });
      console.log(m);
      if (amd == 'transfer') {
        const name = `${fields.familyName}${fields.givenName} `;
        const b = config.mail.registeredBody.toString().match(/(?:\/\*(?:[\s\S]*?)\*\/)/).pop().replace(/^\/\*/, "").replace(/\*\/$/, "");
        const ba = b.replaceAll('{{name}}', name).replaceAll('{{}}', "\n").replaceAll('{{memLabel}}', '准会員から正会員への').replaceAll('{{greetingNotice}}', 'お申込みいただいた内容を確認し、資格審査委員会での基本資格審査の合格後に、事務局よりご連絡いたします。').split("\n");

        console.log(b.replaceAll('{{name}}', name));

        let bod = [];
        for (let i in ba) {
          bod.push(ba[i].trim());
        }

        const dests = [];
        dests.push({
          pk:m.pk,
          familyName:fields.familyName,
          givenName:fields.givenName,
          familyNameKana:fields.familyNameKana,
          givenNameKana:fields.givenNameKana,
          memberId:fields.loginId,
          affiliationName:fields.affiliationName,
          affiliationEmail:fields.affiliationEmail,
          admissionDate:fields.admissionDate,
          updatedAt: Date.now()
        });

          let fromName = '【日本臨床スポーツ医学会】';
          fromName = libmime.encodeWord(fromName, 'Q');
          const r = await sendMail({
              subject: ('准会員から正会員') + config.mail.registeredMailSubject,
              from: fromName + ' <' + config.mail.source + '>',
              to: fields.affiliationEmail,
              bcc: config.mail.bcc,
              mailBody:bod.join("\n"),
              enableLog: false,
              fromEmail: config.mail.source,
	      fromName: '【日本臨床スポーツ医学会】',
              dests: dests
          });
          console.log(r);
          if (r.statusCode == 500) {
            console.error(r.statusCode + ':');
            console.error(r.body);
            throw new Error(r.body);
          } else if (r.statusCode != 200) {
            console.error(r.statusCode + ':');
            throw new Error('Eメールを送信中にエラーが発生しました。');
          }
      }
      history.push((isAdmin) ? (reff == 'mm' ? '/admin/memberships?m=rc' : '/admin') : "/home");
    } catch (e) {
      onError(e);
      setIsLoading(false);
    }
    setIsLoading(false);
  }


  function validateConfirmationForm() {
    //return fields.confirmationCode.length > 0;
    return true;
  }

 function handleMemCommitteeChange(event) {
    const n = event.target.name;
//    console.log(n.substring('memCommittee'.length));
    const i = parseInt(n.substring('memCommittee'.length));
    let chs = JSON.parse(JSON.stringify(memCommittee));
    chs[i] = event.target.checked ? parseInt(event.target.value) : 0;
//    console.log(chs);
    setMemCommittee(chs);
  }

 function handleMemRepresentativeChange(event) {
    const n = event.target.name;
//    console.log(n.substring('memCommittee'.length));
    const i = parseInt(n.substring('memRepresentative'.length));
    let chs = JSON.parse(JSON.stringify(memRepresentative));
    chs[i] = event.target.checked ? 1 : 0;
//    console.log(chs);
    setMemRepresentative(chs);
  }

  const  handleNext = (event) => {
    event.preventDefault();
    console.log('handleNext:' + memType);
    glMemType = memType;
    if (!validateForm()) {
      updateValidationMessages();
      console.log("Messages.....");
      console.log(messages);
      let hasErr = false;
      for (const elm of Object.keys(messages)) {
        if (messages[elm].n.length > 0) {
          if (!document.getElementById(elm)) continue;
          hasErr = true;
          console.log(elm);
          document.getElementById(elm).scrollIntoView();
          break;
        }
      }
      console.log('hasErr 1t: ' + hasErr);
        if (!hasErr)
        for (const elm of Object.keys(vldNamesByHand)) {
          console.log('vldNamesByHand : ');
          console.log(elm);
          if (vldNamesByHand[elm].length > 0) {
            if (!document.getElementById(elm)) {
		console.log('couldnot find ' + elm + ', so skipping');
                continue;
	    }
            hasErr = true;
            console.log(elm);
            console.log(vldNamesByHand[elm]);
            document.getElementById(elm).scrollIntoView();
            break;
	  }
        }
        console.log('hasErr ' + hasErr);
        //
	if (hasErr == true) return true;
    }
    console.log('handleOnNext...' + opType);
    console.log(event);
    console.log(amd);
    setPage('confirm');
    window.scrollTo(0, 0);
    return false;
  }

  const popBack = (e) => {
      console.log('pop back');
      history.goBack();
  };
  const showAdminOptionItems = (show) => {
      console.log('showAdminOptionItems...' + show);
      const associatem = document.getElementsByClassName('associatem');
//      console.log(associatem);
      for (let i=0; i < associatem.length; i++) {
          associatem[i].style.display = show ? '' : 'none';
      }
  };
  const handleMemTypeChanged = (e) => {
    const v = e.target.value;
    console.log('handleMemTypeChanged...' + v);
    setMemType(v);
      const ot = (v == 1 || v == 2 || v == 3 ? 1 : (v == 4 || v == 5 || v == 6 || v == 10 || v == 7 || v == 8 || v == 11 ? 2 : 3));
    setOpType(ot);
    showAdminOptionItems(v != 1 && v != 2 && v != 3 && v != 4 && v != 5 && v != 6 && v != 10);
  };

  // A Pane
    const administrativeAttrsForm = isAdmin ? <AdministrativeAttrsForm amd={amd} fields={fields} handleFieldChange={handleFieldChange} memStatus={memStatus} setMemStatus={setMemStatus} savedType={savedType} memType={memType} handleMemTypeChanged={handleMemTypeChanged}　memClass={memClass} setMemClass={setMemClass} memPost={memPost} setMemPost={setMemPost} handleMemPostChange={handleMemPostChange} memCommittee={memCommittee} setMemCommittee={setMemCommittee} handleMemCommitteeChange={handleMemCommitteeChange} memPaymentMethod={memPaymentMethod} setMemPaymentMethod={setMemPaymentMethod} memRepresentative={memRepresentative} setMemRepresentative={setMemRepresentative} handleMemRepresentativeChange={handleMemRepresentativeChange} memStatus4Label={memStatus4Label} messages={messages} page="page" /> : <></>;
    const administrativeAttrsConfirm = isAdmin ? <AdministrativeAttrsConfirm amd={amd} fields={fields} memStatus={memStatus} memType={memType} memClass={memClass} memPost={memPost} memCommittee={memCommittee} memRepresentative={memRepresentative} memPaymentMethod={memPaymentMethod}/> : <></>;

  // E Pane
  const basicDomainInfoForm = opType == 1 || memType == 3 ? <BasicDomainInfoForm fields={fields} handleFieldChange={handleFieldChange} basicDomainOtherMessage={basicDomainOtherMessage} expertDomainChecks={expertDomainChecks} handleExpertDomainChecksChange={handleExpertDomainChecksChange} expertDomainChecksMessage={expertDomainChecksMessage} expertDomainOtherMessage={expertDomainOtherMessage} primaryGames={primaryGames} handlePrimaryGamesChange={handlePrimaryGamesChange} primaryGamesMessage={primaryGamesMessage} messages={messages} page="page" isEdit={true}/> : <></>;
  const basicDomainInfoConfirm = opType == 1 || memType == 3 ? <BasicDomainInfoConfirm fields={fields} expertDomainChecks={expertDomainChecks} primaryGames={primaryGames}/> : <></>;

  // G,H Panes
  const certificationInfoForm = opType == 1 || memType == 3 ? <CertificationInfoForm fields={fields} handleFieldChange={handleFieldChange} 
                                  memType={memType}
                                  cert1Checks={cert1Checks} handleCert1ChecksChange={handleCert1ChecksChange}
                                  cert1ChecksMessage={ cert1ChecksMessage }
                                  messages={messages} page="page" isEdit={true}
        /> : <></>;
  const certificationInfoConfirm = opType == 1 || memType == 3 ? <CertificationInfoConfirm fields={fields} 
                                     cert1Checks={cert1Checks}
        /> : <></>;

  // I Pane
    const certificationInfo2Form = (opType == 2 || opType === 3 || opType === 4 || memType == 6) && !(memType == 14 || memType == 15 || memType == 16 || memType == 17) ? <CertificationInfo2FormV2 
                                     fields={fields} handleFieldChange={handleFieldChange}
                                     cert2Checks={cert2Checks} handleCert2ChecksChange={handleCert2ChecksChange}
                                     cert2ChecksMessage={ cert2ChecksMessage }
                                     messages={messages} page="page" isEdit={true}/> : <></>;
    const certificationInfo2Confirm = (opType == 2 || opType === 3 || opType === 4 || memType == 6) && !(memType == 14 || memType == 15 || memType == 16 || memType == 17) ? <CertificationInfo2ConfirmV2 fields={fields} 
                                     cert2Checks={cert2Checks}
        /> : <></>;


  // J Pane
  const recommendersInfoForm = (opType == 4 || opType == 2 || memType == 6 || opType == 14 || amd == 'transfer' || memType == 14 || memType == 15 || memType == 16 || memType == 17) && isAdmin ? <RecommendersInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={true}/> : <></>;
  const recommendersInfoConfirm = (opType == 4 || opType == 2 || memType == 6 || opType == 14 || amd == 'transfer' || memType == 14 || memType == 15 || memType == 16 || memType == 17) && isAdmin ? <RecommendersInfoConfirm fields={fields} /> : <></>;

  // K Pane
    const recommendersInfo2Form = ((amd == 'transfer' || (opType == 2 && isAdmin) && !(memType == 4 || memType == 5 || memType == 6 || memType == 10)) && !(memType == 14 || memType == 15 ||  memType == 16 || memType == 17)) ? <RecommendersInfo2Form fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" /> : <></>;
    const recommendersInfo2Confirm = ((amd == 'transfer' || (opType == 2 && isAdmin) && !(memType == 4 || memType == 5 || memType == 6 || memType == 10)) && !(memType == 14 || memType == 15 ||  memType == 16 || memType == 17)) ? <RecommendersInfo2Confirm fields={fields} /> : <></>;

  // L Pane
  const othersInfoForm = (opType == 4 || opType == 2 || memType == 6 || opType == 14 || memType == 14 || memType == 15 || memType == 16 || memType == 17) && (amd == 'transfer' || isAdmin) ? <OthersInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={true} isTransfer={amd == 'transfer'} /> : <></>;
  const othersInfoConfirm = (opType == 4 || opType == 2 || memType == 6 || opType == 14 || memType == 14 || memType == 15 || memType == 16 || memType == 17) && (amd == 'transfer' || isAdmin) ? <OthersInfoConfirm fields={fields} isTransfer={amd == 'transfer'} /> : <></>;

  // M Pane
  const membersInfo = (opType == 1 || opType == 2 || opType == 14) ? <MembersInfo fields={fields} handleFieldChange={handleFieldChange} memStatus={memStatus} memType={memType} memClass={memClass} memPost={memPost} memCommittee={memCommittee} memRepresentative={memRepresentative} messages={messages} page="page" /> : <></>;

  const back = (event) => { 
    console.log(event.target.id);
    if ('backToList' == event.target.id) {
      console.log(reff);
      const p = (reff == "mm") ?  '/admin/memberships?m=rc' : '/admin'; // membership management : mma
      history.push(p);
    } else {
      setPage('input');
    }
    window.scrollTo(0, 0);    
  };

  const sendMail = (data) => {
    return API.post('sakurajima', '/sendmail', {
      body: data
    });
  };

  function renderConfirmationForm() {
    return (
      <>
        <div id="registration" className="confirm">
          <section>
            { administrativeAttrsConfirm }
            <RegistrationInfoConfirm 
              fields={fields} gender={gender}
              destination={destination}
              viewMode={false}
            />
            <AffiliationInfoConfirm
              fields={fields} 
              viewMode={false}
              mt={memType}
            />
            <HomeInfoConfirm
              fields={fields} 
              viewMode={false}
            />
            { basicDomainInfoConfirm }
            <AcademicHistoryInfoConfirm
              fields={fields} 
              graduate={graduate} 
              viewMode={false} mt={memType}
            />
            { certificationInfoConfirm }
            { certificationInfo2Confirm }
            {recommendersInfoConfirm}
            {recommendersInfo2Confirm}
            {othersInfoConfirm}

        <Form onSubmit={handleConfirmationSubmit}>
        <div className="btn">
          <Button id="prev" active size="lg" active onClick={ back } >
            戻る
          </Button>
          <LoaderButton
            active
            size="lg"
            type="submit"
            id="regist"
            variant="success"
            isLoading={isLoading}
            disabled={!validateConfirmationForm()}
          >
          申込み
          </LoaderButton>
        </div>
        </Form>
	    {/*
      <Form onSubmit={handleConfirmationSubmit}>
        <Form.Group controlId="confirmationCode" size="lg">
          <Form.Label>Confirmation Code</Form.Label>
          <Form.Control
            type="tel"
            onChange={handleFieldChange}
            value={fields.confirmationCode}
          />
          <Form.Text muted>Please check your Login ID for the code.</Form.Text>
        </Form.Group>
        <Button id="prev" active size="lg" active onClick={ back } >
          戻る
        </Button>
        <LoaderButton
          active
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          disabled={!validateConfirmationForm()}
        >
          Verify
        </LoaderButton>
      </Form>
	     */}
          </section>
        </div>
      </>
    );
  }

  function renderForm() {
    return (
        <>
      <section>
      <Form onSubmit={handleNext}>
        <div id="registration" className="form">
          <div className="inner">
            {administrativeAttrsForm}
            <RegistrationInfoForm isAdmin={isAdmin} fields={fields} handleFieldChange={handleFieldChange}
               gender={gender} handleSetGender={handleSetGender} genderMessage={genderMessage} 
               destination={destination} handleSetDestination={handleSetDestination} destinationMessage={destinationMessage} 
               messages={messages}  page="page" isEdit={true}
            />
            <AffiliationInfoForm fields={fields} handleFieldChange={handleFieldChange} emailMismatchMessage={emailMismatchMessage}  messages={messages} page="page" isEdit={true} mt={memType}/>
            <HomeInfoForm fields={fields} handleFieldChange={handleFieldChange} messages={messages} page="page" isEdit={true}/>
            {basicDomainInfoForm}
            <AcademicHistoryInfoForm fields={fields} handleFieldChange={handleFieldChange}
              messages={messages} page="page"
              graduate={graduate} handleSetGraduate={handleSetGraduate} graduateMessage={graduateMessage} 
              isEdit={true} mt={memType}
            />
            {certificationInfoForm}
            {certificationInfo2Form}
            {recommendersInfoForm}
            {recommendersInfo2Form}
            {othersInfoForm}
            { amd == 'no' ? membersInfo : ""}

        <Button id="backToList" active size="lg" active onClick={ back } >
          戻る
        </Button>
        <LoaderButton
          block
          size="lg"
          type="submit"
          variant="success"
          isLoading={isLoading}
          id="confirm"
        >
          次へ
        </LoaderButton>
      </div>
          </div>
        </Form>
        <ScrollToTop/>
        </section>
      </>
    );
  }

  const getTitleLabel = () => {
      return (amd === 'mgmt' ? `${memberTypeLabel}情報変更` :  (memType == 7 || memType == 8 || memType == 11 ? '申請情報変更　准会員から正会員' : ( amd == 'transfer' ? '正会員への申請フォーム' : ( amd != 'req' && (memType == 3 || memType == 6) ? `${memberTypeLabel} マイページ` : `${memberTypeLabel} マイページ`))));
  };

  return (
    <div className="Members">
      <main>
          <h1 id="page_title"> { getTitleLabel() } </h1>
      <div className="container">
        <div id="sub_page">
          { member !== null && (page === "confirm" ? renderConfirmationForm() :  renderForm()) }
        </div>
      </div>
      </main>
    </div>
  );
}
